module.exports = __webpack_public_path__ + "static/media/imgop_BBSRC-logo.2fccf8a9.jpg";